module.exports = __webpack_public_path__ + "static/media/9-web-or-mls-DSC06467.bf333fff.jpg";